import router from '@/router'
import VueFlipcard from 'vue-flipcard'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserMd } from '@fortawesome/free-solid-svg-icons'

library.add(faUserMd)

export default {
  name: 'ExpertisePage',
  components: {
    VueFlipcard
  },
  data () {
    return {
      tabs: null,
      tab: null,
      text: 'Texte compétences',
      tab_selected: 0,
      downloadFiles : []
    }
  },
  mounted () {
    this.listDownloadFiles()
  },
  methods: {
    listDownloadFiles() {
      const downloadFileNames = [
        'Info Anti-Résorptif Osseux.pdf',
        'Info Avulsion Dentaires Multiples.pdf',
        'Info Biospies.pdf',
        'Info Conseils post-op.pdf',
        'Info Dent de Sagesse.pdf',
        'Info Desinclusions des dents.pdf',
        'Info Endocardite Infectieuse.pdf',
        'Info Freinectomies.pdf',
        'Info Greffes osseuses autogène.pdf',
        'Info Greffes osseuses exogene.pdf',
        'Info Implants Dentaires.pdf',
        'Info Kystes.pdf',
        'Info Résection Apicale.pdf',
        'Info Sinus lift.pdf',
        'Info Tumeurs de la cavité buccale.pdf'
      ]
      const filesPath = '/static/Files/'

      var downloadFiles = []
      for (var indexFile in downloadFileNames) {
        var downloadFileName = downloadFileNames[indexFile]
        var downloadFile = {
          "location": filesPath + downloadFileName,
          "name": downloadFileName
        }
        downloadFiles.push(downloadFile)
      }
      this.downloadFiles = downloadFiles
    },
    redirectTo(url) {
      if(url) {
        this.$router.push(url)
      }
    }
  },
  computed: {
  }
}



// WEBPACK FOOTER //
// ./src/views/pages/expertise/expertise.component.js